// const LEAD_URI = ("https://stagingbrptv.mototvnetwork.net/ryker/v1/send-configuration/"); // Staging URI

const LEAD_URI = ("https://brptv.mototvnetwork.net/ryker/v1/send-configuration/"); // production URI
 
export class FormSubmission {
  constructor() {
    this._headers = {
      "Authorization": `Basic ` + btoa("rykerapp:UU@t95k*D012;?Ix<?M0;14!FXlqR>u?FGF%Rl0p?KwD1@gST"),  // Prod authorization
      // "Authorization": `Basic ` + btoa("rykerappstaging:%xQO@He^MGe$Q3*C2"),  // Staging authorization
      "cache-control" : "no-cache"
    }

    console.log(this._headers);
  }

  async createLead(salesLead, playerID) {
    const postURL = LEAD_URI.concat(playerID);

      var form = new FormData();
      form.append("configuration", salesLead);

    return this._post(postURL, form);
  }

  async _post(uri, body) {
      console.log(body)
    const response = await fetch(uri, {
        method: "POST",
        cache: "no-cache",
        headers: this._headers,
        body: body
    });
    if (!response.ok) {
        const error = await response.text();
        throw new Error(error);
    }
    return response;
  }
}


// WEBPACK FOOTER //
// ./src/services/FormSubmission.js